import React from "react";

const HeroSection = () => {
  return (
    <section className="candidate">
      <div className="bg-image-candidate">
        <div className="bg-overlay-candidate"></div>
        <div className="container content-candidate">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <h2>Candidates</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
